import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";

import { quotaQueries } from "~/modules/quota/api/quota/quotaQueries.ts";
import type { QuotaConsumerOrderInfo } from "~/modules/quota/components/formSections/QuotaConsumersFormSection.tsx";

// Resolve the display labels of each available consumer order once, keyed by order id.
export const useQuotaConsumerOrderInfo = (companyId: string) => {
	const { data: availableConsumersData } = useQuery(quotaQueries.availableConsumers(companyId));

	return useMemo(() => {
		const map: Record<string, QuotaConsumerOrderInfo> = {};
		if (!availableConsumersData) {
			return map;
		}
		const projectTitleById = new Map(
			availableConsumersData.projects.map(project => [project.id, project.title]),
		);
		const phaseTitleById = new Map<string, string>();
		availableConsumersData.projects.forEach(project => {
			project.phases.forEach(phase => phaseTitleById.set(phase.id, phase.title));
		});
		availableConsumersData.orders.forEach(order => {
			map[order.id] = {
				orderTitle: order.title,
				phaseTitle: phaseTitleById.get(order.projectPhaseId) ?? "",
				projectTitle: projectTitleById.get(order.projectId) ?? "",
				projectId: order.projectId,
			};
		});
		return map;
	}, [availableConsumersData]);
};
